import React from 'react';

/**
* Border component for Home
*/
export const Border = props => 
  <hr className='tw-border-t tw-border-sideBorder' />
  

export default Border;